export default function ManagementHeader({name, email, image, onChangeInstructor, isLoading = false}){
    return(
        <div className="relative bg-gray-200 rounded-xl p-8 pl-28 flex items-center justify-between shadow">
            <div className="flex items-center space-x-4">
                <img
                    src={image || "https://ui-avatars.com/api/?name=" + encodeURIComponent(name) + "&background=e5e7eb&color=374151&size=144"}
                    alt={name}
                    className="absolute top-1/2 -translate-y-1/2 w-36 h-36 rounded-full border-2 border-white object-cover shadow-lg"
                    onError={(e) => {
                        e.target.src = "https://ui-avatars.com/api/?name=" + encodeURIComponent(name) + "&background=e5e7eb&color=374151&size=144";
                    }}
                />
            </div>
            <div className="flex-1 justify-between pl-40">
                <div className="text-sm text-black-600 font-medium">Period Instructor</div>
                <div className="text-lg font-semibold text-slate-800">{name}</div>
                <div className="text-sm text-blue-600 mb-2">{email}</div>
                <button 
                    onClick={onChangeInstructor}
                    disabled={isLoading}
                    className={`px-3 py-1.5 rounded-lg transition-colors flex items-center space-x-2 text-sm ${
                        isLoading 
                            ? 'bg-gray-400 text-white cursor-not-allowed' 
                            : 'bg-blue-600 text-white hover:bg-blue-700'
                    }`}
                >
                    {isLoading ? (
                        <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    ) : (
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                        </svg>
                    )}
                    <span>{isLoading ? 'Updating...' : 'Change Instructor'}</span>
                </button>
            </div>
            <button className="bg-white rounded-full px-4 py-2 text-sm font-medium text-slate-800 shadow flex items-center gap-1">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeWidth="2" d="M12 12c2.21 0 4-1.79 4-4S14.21 4 12 4 8 5.79 8 8s1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
          </svg>
          Profile
          </button>
        </div>
    );
}